module.exports = __webpack_public_path__ + "static/media/users.79e3a5ba.svg";